module.exports = __webpack_public_path__ + "media/images/logo__smashgc-d59e30f464c2d8b152589cabca1c7915.png";